import ImmunizationResult from '../../model/immunizationResult'
import mapUser from './userMapper'
import moment from 'moment';

/*
    example single response in results array
    {
        immunizationName: "Corona Phizer",
        immunizationDate: "2020-10-10",
        locationName: "Fredericton DECH"5
    },
*/
export function mapImmunizationResults(data) {
    const results = data.immunizations.map(i => {
        const date = moment(i.immunizationDate, moment.ISO_8601);
        return new ImmunizationResult(i.immunizationName, i.immunizationNameFr, date, i.locationName, i.immunizationStatus)
    })

    const user = mapUser(data);

    // Sort results by date..
    let sortedResults = results.sort(function(a, b) {
        return b.immunizationDate - a.immunizationDate;
    });
    return { user, sortedResults };
}
